import CookieAlertModule from '@/modules/cookieAlert/CookieAlertModule'
import { mount } from '@/mounter'

mount('cookie-alert', CookieAlertModule)
